export enum MutationTypes {
    SET_THEME = 'browser-module/set-theme',
}

